/**
 * Chỉ cho phép quay lại một đường dẫn nội bộ sau khi đăng nhập/đăng ký.
 * Chặn URL tuyệt đối (kể cả `//evil.com`, `/\evil.com`) để tránh open redirect
 * và để môi trường dev/staging không bị đẩy sang production.
 */
export function safeCallbackUrl(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  return raw;
}
